import { LuInbox } from "react-icons/lu";

const EmptyState = ({
  title = "No records found",
  message = "Try changing your search or filters.",
  onClear,
}: {
  title?: string;
  message?: string;
  onClear?: () => void;
}) => (
  <div className="flex flex-col items-center justify-center py-16 px-5 text-center">
    <div className="w-14 h-14 rounded-full bg-hc_F4EBFA text-honeConnectPurple flex items-center justify-center mb-4">
      <LuInbox className="text-2xl" />
    </div>
    <p className="font-semibold text-honeConnectBlack mb-1">{title}</p>
    <p className="text-sm text-hcMuted mb-4">{message}</p>
    {onClear && (
      <button
        onClick={onClear}
        className="text-sm font-semibold text-honeConnectPurple hover:underline"
      >
        Clear filters
      </button>
    )}
  </div>
);

export default EmptyState;
